import { RefObject, useEffect } from "react";

function useInputFocus(className: string, trigger: boolean, dep: any[]): void;
function useInputFocus(
  ref: RefObject<HTMLInputElement>,
  trigger: boolean,
  dep: any[]
): void;
export function useInputFocus(
  ref: string | RefObject<HTMLInputElement>,
  trigger: boolean,
  dep = [] as any[]
) {
  useEffect(() => {
    if (trigger) {
      if (typeof ref === "string") {
        document.querySelector(ref)?.focus();
      } else {
        ref.current?.focus();
      }
    } else {
      if (typeof ref === "string") {
        document.querySelector(ref)?.blur();
      } else {
        ref.current?.blur();
      }
    }
  }, [trigger, ...dep]);
}
